import React from 'react';
import Layout from 'components/styled/Layout/Layout';
import TopBar from 'components/Header/TopBar/TopBar';
import Header from 'components/Header/Header';
import InViewObserver from 'components/utility/InViewObserver/InViewObserver';
import {
  Header as HeaderWrapper,
  HeaderContainer,
  ContentWrapper,
  Title,
} from './shared/styles';

const SystemStatusHeader: React.FC = () => {
  return (
    <InViewObserver
      render={({ inview }: any): JSX.Element => (
        <Header inView={inview} withVerticalBackground>
          <TopBar
            entityTitle="Opus System Status"
            inView={inview}
            isSticky
            simpleTextTopBar
          />
          <Layout.MaxWidth>
            <HeaderContainer>
              <HeaderWrapper simpleTextTopBar>
                <ContentWrapper data-pw="header-system-status">
                  <Title>Opus System Status</Title>
                </ContentWrapper>
              </HeaderWrapper>
            </HeaderContainer>
          </Layout.MaxWidth>
        </Header>
      )}
    />
  );
};

export default SystemStatusHeader;
